interface FAQItem {
  question: string;
  answer: string;
}

interface FAQListProps {
  items: FAQItem[];
}

export default function FAQList({ items }: FAQListProps) {
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error("FAQList: `items` array is empty or invalid.");
  }

  return (
    <div className="faq">
      {items.map((item, index) => (
        <details key={item.question} open={index === 0}>
          <summary>{item.question}</summary>
          <div className="faq-body">
            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
          </div>
        </details>
      ))}
    </div>
  );
}
